import produce from 'immer'
import { assign } from 'lodash'

import { createSelectOptions } from '../../helpers'
import { COMMON_FETCH_USERS } from '../action-types'
import { USERS_INITIAL_STATE } from '../initial-states'

const usersReducer = (state = USERS_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_USERS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: [],
          options: undefined,
        }),
      )

    case COMMON_FETCH_USERS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.users.results,
          options: createSelectOptions(
            action.payload.data.users.results,
            'name',
            'id',
          ),
        }),
      )

    case COMMON_FETCH_USERS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: [],
          options: undefined,
        }),
      )

    case COMMON_FETCH_USERS.CLEANUP:
      return { ...USERS_INITIAL_STATE }

    default:
      return state
  }
}

export default usersReducer
